import apiFetch from '../../apiFetch'

export default function (ubicacionAnadidas, token) {
  return apiFetch({endPoint: `Bioseguridad/getUbicaciones`, method: 'POST', body: ubicacionAnadidas, token: token})
}
